import React, { useState } from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import type { UserProfile } from '../../auth';

interface AdminLayoutProps {
  children: React.ReactNode;
  activePage: string;
  onPageChange: (page: string) => void;
  onLogout?: () => void;
  userProfile?: UserProfile | null;
}

export const AdminLayout: React.FC<AdminLayoutProps> = ({ children, activePage, onPageChange, onLogout, userProfile }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  return (
    <div className="flex h-screen overflow-hidden bg-white">
      {/* Sidebar - Desktop: static width, Mobile: fixed overlay */}
      <Sidebar 
        activePage={activePage} 
        onPageChange={(page) => {
          onPageChange(page);
          setIsSidebarOpen(false);
        }}
        isOpen={isSidebarOpen}
        onLogout={onLogout}
        userProfile={userProfile}
      />
      
      {/* Main Content Area */}
      <div className="flex-1 flex flex-col min-w-0">
        <Header onMenuToggle={toggleSidebar} />
        
        <main className="flex-1 overflow-y-auto">
          {children}
        </main>
      </div>

      {/* Mobile Sidebar Overlay */}
      {isSidebarOpen && (
        <div 
          className="fixed inset-0 bg-black/50 z-30 md:hidden" 
          onClick={toggleSidebar}
        />
      )}
    </div>
  );
};
